/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3ab6d06ceee07a33f01831ba39d1781a>>
 * @codegenCommand yarn build tokens
 */

type TokenValue =
	| string
	| number;

type TokenValueOriginal =
	| string
	| number;

type TokenAttributes = {
	group: string;
	category: string;
};


type Token = {
	value: TokenValue;
	filePath: string;
	isSource: boolean;
	attributes: TokenAttributes;
	original: {
		value: TokenValueOriginal;
		attributes: TokenAttributes;
	};
	name: string;
	path: string[];

};

const tokens: Token[] = [
  {
    "value": "#EFFFD6",
    "attributes": {
      "group": "palette",
      "category": "lime"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#EFFFD6",
      "attributes": {
        "group": "palette",
        "category": "lime"
      }
    },
    "name": "color.palette.Lime100",
    "path": [
      "color",
      "palette",
      "Lime100"
    ]
  },
  {
    "value": "#D3F1A7",
    "attributes": {
      "group": "palette",
      "category": "lime"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#D3F1A7",
      "attributes": {
        "group": "palette",
        "category": "lime"
      }
    },
    "name": "color.palette.Lime200",
    "path": [
      "color",
      "palette",
      "Lime200"
    ]
  },
  {
    "value": "#BDE97C",
    "attributes": {
      "group": "palette",
      "category": "lime"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#BDE97C",
      "attributes": {
        "group": "palette",
        "category": "lime"
      }
    },
    "name": "color.palette.Lime250",
    "path": [
      "color",
      "palette",
      "Lime250"
    ]
  },
  {
    "value": "#B3DF72",
    "attributes": {
      "group": "palette",
      "category": "lime"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#B3DF72",
      "attributes": {
        "group": "palette",
        "category": "lime"
      }
    },
    "name": "color.palette.Lime300",
    "path": [
      "color",
      "palette",
      "Lime300"
    ]
  },
  {
    "value": "#94C748",
    "attributes": {
      "group": "palette",
      "category": "lime"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#94C748",
      "attributes": {
        "group": "palette",
        "category": "lime"
      }
    },
    "name": "color.palette.Lime400",
    "path": [
      "color",
      "palette",
      "Lime400"
    ]
  },
  {
    "value": "#82B536",
    "attributes": {
      "group": "palette",
      "category": "lime"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#82B536",
      "attributes": {
        "group": "palette",
        "category": "lime"
      }
    },
    "name": "color.palette.Lime500",
    "path": [
      "color",
      "palette",
      "Lime500"
    ]
  },
  {
    "value": "#6A9A23",
    "attributes": {
      "group": "palette",
      "category": "lime"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#6A9A23",
      "attributes": {
        "group": "palette",
        "category": "lime"
      }
    },
    "name": "color.palette.Lime600",
    "path": [
      "color",
      "palette",
      "Lime600"
    ]
  },
  {
    "value": "#5B7F24",
    "attributes": {
      "group": "palette",
      "category": "lime"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#5B7F24",
      "attributes": {
        "group": "palette",
        "category": "lime"
      }
    },
    "name": "color.palette.Lime700",
    "path": [
      "color",
      "palette",
      "Lime700"
    ]
  },
  {
    "value": "#4C6B1F",
    "attributes": {
      "group": "palette",
      "category": "lime"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#4C6B1F",
      "attributes": {
        "group": "palette",
        "category": "lime"
      }
    },
    "name": "color.palette.Lime800",
    "path": [
      "color",
      "palette",
      "Lime800"
    ]
  },
  {
    "value": "#3F5224",
    "attributes": {
      "group": "palette",
      "category": "lime"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#3F5224",
      "attributes": {
        "group": "palette",
        "category": "lime"
      }
    },
    "name": "color.palette.Lime850",
    "path": [
      "color",
      "palette",
      "Lime850"
    ]
  },
  {
    "value": "#37471F",
    "attributes": {
      "group": "palette",
      "category": "lime"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#37471F",
      "attributes": {
        "group": "palette",
        "category": "lime"
      }
    },
    "name": "color.palette.Lime900",
    "path": [
      "color",
      "palette",
      "Lime900"
    ]
  },
  {
    "value": "#28311B",
    "attributes": {
      "group": "palette",
      "category": "lime"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#28311B",
      "attributes": {
        "group": "palette",
        "category": "lime"
      }
    },
    "name": "color.palette.Lime1000",
    "path": [
      "color",
      "palette",
      "Lime1000"
    ]
  },
  {
    "value": "#FFECEB",
    "attributes": {
      "group": "palette",
      "category": "red"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#FFECEB",
      "attributes": {
        "group": "palette",
        "category": "red"
      }
    },
    "name": "color.palette.Red100",
    "path": [
      "color",
      "palette",
      "Red100"
    ]
  },
  {
    "value": "#FFD5D2",
    "attributes": {
      "group": "palette",
      "category": "red"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#FFD5D2",
      "attributes": {
        "group": "palette",
        "category": "red"
      }
    },
    "name": "color.palette.Red200",
    "path": [
      "color",
      "palette",
      "Red200"
    ]
  },
  {
    "value": "#FFB8B2",
    "attributes": {
      "group": "palette",
      "category": "red"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#FFB8B2",
      "attributes": {
        "group": "palette",
        "category": "red"
      }
    },
    "name": "color.palette.Red250",
    "path": [
      "color",
      "palette",
      "Red250"
    ]
  },
  {
    "value": "#FD9891",
    "attributes": {
      "group": "palette",
      "category": "red"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#FD9891",
      "attributes": {
        "group": "palette",
        "category": "red"
      }
    },
    "name": "color.palette.Red300",
    "path": [
      "color",
      "palette",
      "Red300"
    ]
  },
  {
    "value": "#F87168",
    "attributes": {
      "group": "palette",
      "category": "red"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#F87168",
      "attributes": {
        "group": "palette",
        "category": "red"
      }
    },
    "name": "color.palette.Red400",
    "path": [
      "color",
      "palette",
      "Red400"
    ]
  },
  {
    "value": "#F15B50",
    "attributes": {
      "group": "palette",
      "category": "red"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#F15B50",
      "attributes": {
        "group": "palette",
        "category": "red"
      }
    },
    "name": "color.palette.Red500",
    "path": [
      "color",
      "palette",
      "Red500"
    ]
  },
  {
    "value": "#E2483D",
    "attributes": {
      "group": "palette",
      "category": "red"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#E2483D",
      "attributes": {
        "group": "palette",
        "category": "red"
      }
    },
    "name": "color.palette.Red600",
    "path": [
      "color",
      "palette",
      "Red600"
    ]
  },
  {
    "value": "#C9372C",
    "attributes": {
      "group": "palette",
      "category": "red"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#C9372C",
      "attributes": {
        "group": "palette",
        "category": "red"
      }
    },
    "name": "color.palette.Red700",
    "path": [
      "color",
      "palette",
      "Red700"
    ]
  },
  {
    "value": "#AE2E24",
    "attributes": {
      "group": "palette",
      "category": "red"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#AE2E24",
      "attributes": {
        "group": "palette",
        "category": "red"
      }
    },
    "name": "color.palette.Red800",
    "path": [
      "color",
      "palette",
      "Red800"
    ]
  },
  {
    "value": "#872821",
    "attributes": {
      "group": "palette",
      "category": "red"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#872821",
      "attributes": {
        "group": "palette",
        "category": "red"
      }
    },
    "name": "color.palette.Red850",
    "path": [
      "color",
      "palette",
      "Red850"
    ]
  },
  {
    "value": "#5D1F1A",
    "attributes": {
      "group": "palette",
      "category": "red"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#5D1F1A",
      "attributes": {
        "group": "palette",
        "category": "red"
      }
    },
    "name": "color.palette.Red900",
    "path": [
      "color",
      "palette",
      "Red900"
    ]
  },
  {
    "value": "#42221F",
    "attributes": {
      "group": "palette",
      "category": "red"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#42221F",
      "attributes": {
        "group": "palette",
        "category": "red"
      }
    },
    "name": "color.palette.Red1000",
    "path": [
      "color",
      "palette",
      "Red1000"
    ]
  },
  {
    "value": "#FFF5DB",
    "attributes": {
      "group": "palette",
      "category": "orange"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#FFF5DB",
      "attributes": {
        "group": "palette",
        "category": "orange"
      }
    },
    "name": "color.palette.Orange100",
    "path": [
      "color",
      "palette",
      "Orange100"
    ]
  },
  {
    "value": "#FCE4A6",
    "attributes": {
      "group": "palette",
      "category": "orange"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#FCE4A6",
      "attributes": {
        "group": "palette",
        "category": "orange"
      }
    },
    "name": "color.palette.Orange200",
    "path": [
      "color",
      "palette",
      "Orange200"
    ]
  },
  {
    "value": "#FBD779",
    "attributes": {
      "group": "palette",
      "category": "orange"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#FBD779",
      "attributes": {
        "group": "palette",
        "category": "orange"
      }
    },
    "name": "color.palette.Orange250",
    "path": [
      "color",
      "palette",
      "Orange250"
    ]
  },
  {
    "value": "#FBC828",
    "attributes": {
      "group": "palette",
      "category": "orange"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#FBC828",
      "attributes": {
        "group": "palette",
        "category": "orange"
      }
    },
    "name": "color.palette.Orange300",
    "path": [
      "color",
      "palette",
      "Orange300"
    ]
  },
  {
    "value": "#FCA700",
    "attributes": {
      "group": "palette",
      "category": "orange"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#FCA700",
      "attributes": {
        "group": "palette",
        "category": "orange"
      }
    },
    "name": "color.palette.Orange400",
    "path": [
      "color",
      "palette",
      "Orange400"
    ]
  },
  {
    "value": "#F68909",
    "attributes": {
      "group": "palette",
      "category": "orange"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#F68909",
      "attributes": {
        "group": "palette",
        "category": "orange"
      }
    },
    "name": "color.palette.Orange500",
    "path": [
      "color",
      "palette",
      "Orange500"
    ]
  },
  {
    "value": "#E06C00",
    "attributes": {
      "group": "palette",
      "category": "orange"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#E06C00",
      "attributes": {
        "group": "palette",
        "category": "orange"
      }
    },
    "name": "color.palette.Orange600",
    "path": [
      "color",
      "palette",
      "Orange600"
    ]
  },
  {
    "value": "#BD5B00",
    "attributes": {
      "group": "palette",
      "category": "orange"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#BD5B00",
      "attributes": {
        "group": "palette",
        "category": "orange"
      }
    },
    "name": "color.palette.Orange700",
    "path": [
      "color",
      "palette",
      "Orange700"
    ]
  },
  {
    "value": "#9E4C00",
    "attributes": {
      "group": "palette",
      "category": "orange"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#9E4C00",
      "attributes": {
        "group": "palette",
        "category": "orange"
      }
    },
    "name": "color.palette.Orange800",
    "path": [
      "color",
      "palette",
      "Orange800"
    ]
  },
  {
    "value": "#7A3B00",
    "attributes": {
      "group": "palette",
      "category": "orange"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#7A3B00",
      "attributes": {
        "group": "palette",
        "category": "orange"
      }
    },
    "name": "color.palette.Orange850",
    "path": [
      "color",
      "palette",
      "Orange850"
    ]
  },
  {
    "value": "#693200",
    "attributes": {
      "group": "palette",
      "category": "orange"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#693200",
      "attributes": {
        "group": "palette",
        "category": "orange"
      }
    },
    "name": "color.palette.Orange900",
    "path": [
      "color",
      "palette",
      "Orange900"
    ]
  },
  {
    "value": "#3A2C1F",
    "attributes": {
      "group": "palette",
      "category": "orange"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#3A2C1F",
      "attributes": {
        "group": "palette",
        "category": "orange"
      }
    },
    "name": "color.palette.Orange1000",
    "path": [
      "color",
      "palette",
      "Orange1000"
    ]
  },
  {
    "value": "#FEF7C8",
    "attributes": {
      "group": "palette",
      "category": "yellow"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#FEF7C8",
      "attributes": {
        "group": "palette",
        "category": "yellow"
      }
    },
    "name": "color.palette.Yellow100",
    "path": [
      "color",
      "palette",
      "Yellow100"
    ]
  },
  {
    "value": "#F5E989",
    "attributes": {
      "group": "palette",
      "category": "yellow"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#F5E989",
      "attributes": {
        "group": "palette",
        "category": "yellow"
      }
    },
    "name": "color.palette.Yellow200",
    "path": [
      "color",
      "palette",
      "Yellow200"
    ]
  },
  {
    "value": "#EFDD4E",
    "attributes": {
      "group": "palette",
      "category": "yellow"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#EFDD4E",
      "attributes": {
        "group": "palette",
        "category": "yellow"
      }
    },
    "name": "color.palette.Yellow250",
    "path": [
      "color",
      "palette",
      "Yellow250"
    ]
  },
  {
    "value": "#EED12B",
    "attributes": {
      "group": "palette",
      "category": "yellow"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#EED12B",
      "attributes": {
        "group": "palette",
        "category": "yellow"
      }
    },
    "name": "color.palette.Yellow300",
    "path": [
      "color",
      "palette",
      "Yellow300"
    ]
  },
  {
    "value": "#DDB30E",
    "attributes": {
      "group": "palette",
      "category": "yellow"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#DDB30E",
      "attributes": {
        "group": "palette",
        "category": "yellow"
      }
    },
    "name": "color.palette.Yellow400",
    "path": [
      "color",
      "palette",
      "Yellow400"
    ]
  },
  {
    "value": "#CF9F02",
    "attributes": {
      "group": "palette",
      "category": "yellow"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#CF9F02",
      "attributes": {
        "group": "palette",
        "category": "yellow"
      }
    },
    "name": "color.palette.Yellow500",
    "path": [
      "color",
      "palette",
      "Yellow500"
    ]
  },
  {
    "value": "#B38600",
    "attributes": {
      "group": "palette",
      "category": "yellow"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#B38600",
      "attributes": {
        "group": "palette",
        "category": "yellow"
      }
    },
    "name": "color.palette.Yellow600",
    "path": [
      "color",
      "palette",
      "Yellow600"
    ]
  },
  {
    "value": "#946F00",
    "attributes": {
      "group": "palette",
      "category": "yellow"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#946F00",
      "attributes": {
        "group": "palette",
        "category": "yellow"
      }
    },
    "name": "color.palette.Yellow700",
    "path": [
      "color",
      "palette",
      "Yellow700"
    ]
  },
  {
    "value": "#7F5F01",
    "attributes": {
      "group": "palette",
      "category": "yellow"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#7F5F01",
      "attributes": {
        "group": "palette",
        "category": "yellow"
      }
    },
    "name": "color.palette.Yellow800",
    "path": [
      "color",
      "palette",
      "Yellow800"
    ]
  },
  {
    "value": "#614A05",
    "attributes": {
      "group": "palette",
      "category": "yellow"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#614A05",
      "attributes": {
        "group": "palette",
        "category": "yellow"
      }
    },
    "name": "color.palette.Yellow850",
    "path": [
      "color",
      "palette",
      "Yellow850"
    ]
  },
  {
    "value": "#533F04",
    "attributes": {
      "group": "palette",
      "category": "yellow"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#533F04",
      "attributes": {
        "group": "palette",
        "category": "yellow"
      }
    },
    "name": "color.palette.Yellow900",
    "path": [
      "color",
      "palette",
      "Yellow900"
    ]
  },
  {
    "value": "#332E1B",
    "attributes": {
      "group": "palette",
      "category": "yellow"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#332E1B",
      "attributes": {
        "group": "palette",
        "category": "yellow"
      }
    },
    "name": "color.palette.Yellow1000",
    "path": [
      "color",
      "palette",
      "Yellow1000"
    ]
  },
  {
    "value": "#DCFFF1",
    "attributes": {
      "group": "palette",
      "category": "green"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#DCFFF1",
      "attributes": {
        "group": "palette",
        "category": "green"
      }
    },
    "name": "color.palette.Green100",
    "path": [
      "color",
      "palette",
      "Green100"
    ]
  },
  {
    "value": "#BAF3DB",
    "attributes": {
      "group": "palette",
      "category": "green"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#BAF3DB",
      "attributes": {
        "group": "palette",
        "category": "green"
      }
    },
    "name": "color.palette.Green200",
    "path": [
      "color",
      "palette",
      "Green200"
    ]
  },
  {
    "value": "#97EDC9",
    "attributes": {
      "group": "palette",
      "category": "green"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#97EDC9",
      "attributes": {
        "group": "palette",
        "category": "green"
      }
    },
    "name": "color.palette.Green250",
    "path": [
      "color",
      "palette",
      "Green250"
    ]
  },
  {
    "value": "#7EE2B8",
    "attributes": {
      "group": "palette",
      "category": "green"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#7EE2B8",
      "attributes": {
        "group": "palette",
        "category": "green"
      }
    },
    "name": "color.palette.Green300",
    "path": [
      "color",
      "palette",
      "Green300"
    ]
  },
  {
    "value": "#4BCE97",
    "attributes": {
      "group": "palette",
      "category": "green"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#4BCE97",
      "attributes": {
        "group": "palette",
        "category": "green"
      }
    },
    "name": "color.palette.Green400",
    "path": [
      "color",
      "palette",
      "Green400"
    ]
  },
  {
    "value": "#2ABB7F",
    "attributes": {
      "group": "palette",
      "category": "green"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#2ABB7F",
      "attributes": {
        "group": "palette",
        "category": "green"
      }
    },
    "name": "color.palette.Green500",
    "path": [
      "color",
      "palette",
      "Green500"
    ]
  },
  {
    "value": "#22A06B",
    "attributes": {
      "group": "palette",
      "category": "green"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#22A06B",
      "attributes": {
        "group": "palette",
        "category": "green"
      }
    },
    "name": "color.palette.Green600",
    "path": [
      "color",
      "palette",
      "Green600"
    ]
  },
  {
    "value": "#1F845A",
    "attributes": {
      "group": "palette",
      "category": "green"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#1F845A",
      "attributes": {
        "group": "palette",
        "category": "green"
      }
    },
    "name": "color.palette.Green700",
    "path": [
      "color",
      "palette",
      "Green700"
    ]
  },
  {
    "value": "#216E4E",
    "attributes": {
      "group": "palette",
      "category": "green"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#216E4E",
      "attributes": {
        "group": "palette",
        "category": "green"
      }
    },
    "name": "color.palette.Green800",
    "path": [
      "color",
      "palette",
      "Green800"
    ]
  },
  {
    "value": "#19573D",
    "attributes": {
      "group": "palette",
      "category": "green"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#19573D",
      "attributes": {
        "group": "palette",
        "category": "green"
      }
    },
    "name": "color.palette.Green850",
    "path": [
      "color",
      "palette",
      "Green850"
    ]
  },
  {
    "value": "#164B35",
    "attributes": {
      "group": "palette",
      "category": "green"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#164B35",
      "attributes": {
        "group": "palette",
        "category": "green"
      }
    },
    "name": "color.palette.Green900",
    "path": [
      "color",
      "palette",
      "Green900"
    ]
  },
  {
    "value": "#1C3329",
    "attributes": {
      "group": "palette",
      "category": "green"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#1C3329",
      "attributes": {
        "group": "palette",
        "category": "green"
      }
    },
    "name": "color.palette.Green1000",
    "path": [
      "color",
      "palette",
      "Green1000"
    ]
  },
  {
    "value": "#E7F9FF",
    "attributes": {
      "group": "palette",
      "category": "teal"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#E7F9FF",
      "attributes": {
        "group": "palette",
        "category": "teal"
      }
    },
    "name": "color.palette.Teal100",
    "path": [
      "color",
      "palette",
      "Teal100"
    ]
  },
  {
    "value": "#C6EDFB",
    "attributes": {
      "group": "palette",
      "category": "teal"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#C6EDFB",
      "attributes": {
        "group": "palette",
        "category": "teal"
      }
    },
    "name": "color.palette.Teal200",
    "path": [
      "color",
      "palette",
      "Teal200"
    ]
  },
  {
    "value": "#B1E4F7",
    "attributes": {
      "group": "palette",
      "category": "teal"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#B1E4F7",
      "attributes": {
        "group": "palette",
        "category": "teal"
      }
    },
    "name": "color.palette.Teal250",
    "path": [
      "color",
      "palette",
      "Teal250"
    ]
  },
  {
    "value": "#9DD9EE",
    "attributes": {
      "group": "palette",
      "category": "teal"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#9DD9EE",
      "attributes": {
        "group": "palette",
        "category": "teal"
      }
    },
    "name": "color.palette.Teal300",
    "path": [
      "color",
      "palette",
      "Teal300"
    ]
  },
  {
    "value": "#6CC3E0",
    "attributes": {
      "group": "palette",
      "category": "teal"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#6CC3E0",
      "attributes": {
        "group": "palette",
        "category": "teal"
      }
    },
    "name": "color.palette.Teal400",
    "path": [
      "color",
      "palette",
      "Teal400"
    ]
  },
  {
    "value": "#42B2D7",
    "attributes": {
      "group": "palette",
      "category": "teal"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#42B2D7",
      "attributes": {
        "group": "palette",
        "category": "teal"
      }
    },
    "name": "color.palette.Teal500",
    "path": [
      "color",
      "palette",
      "Teal500"
    ]
  },
  {
    "value": "#2898BD",
    "attributes": {
      "group": "palette",
      "category": "teal"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#2898BD",
      "attributes": {
        "group": "palette",
        "category": "teal"
      }
    },
    "name": "color.palette.Teal600",
    "path": [
      "color",
      "palette",
      "Teal600"
    ]
  },
  {
    "value": "#227D9B",
    "attributes": {
      "group": "palette",
      "category": "teal"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#227D9B",
      "attributes": {
        "group": "palette",
        "category": "teal"
      }
    },
    "name": "color.palette.Teal700",
    "path": [
      "color",
      "palette",
      "Teal700"
    ]
  },
  {
    "value": "#206A83",
    "attributes": {
      "group": "palette",
      "category": "teal"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#206A83",
      "attributes": {
        "group": "palette",
        "category": "teal"
      }
    },
    "name": "color.palette.Teal800",
    "path": [
      "color",
      "palette",
      "Teal800"
    ]
  },
  {
    "value": "#1A5265",
    "attributes": {
      "group": "palette",
      "category": "teal"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#1A5265",
      "attributes": {
        "group": "palette",
        "category": "teal"
      }
    },
    "name": "color.palette.Teal850",
    "path": [
      "color",
      "palette",
      "Teal850"
    ]
  },
  {
    "value": "#164555",
    "attributes": {
      "group": "palette",
      "category": "teal"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#164555",
      "attributes": {
        "group": "palette",
        "category": "teal"
      }
    },
    "name": "color.palette.Teal900",
    "path": [
      "color",
      "palette",
      "Teal900"
    ]
  },
  {
    "value": "#1E3137",
    "attributes": {
      "group": "palette",
      "category": "teal"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#1E3137",
      "attributes": {
        "group": "palette",
        "category": "teal"
      }
    },
    "name": "color.palette.Teal1000",
    "path": [
      "color",
      "palette",
      "Teal1000"
    ]
  },
  {
    "value": "#E9F2FE",
    "attributes": {
      "group": "palette",
      "category": "blue"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#E9F2FE",
      "attributes": {
        "group": "palette",
        "category": "blue"
      }
    },
    "name": "color.palette.Blue100",
    "path": [
      "color",
      "palette",
      "Blue100"
    ]
  },
  {
    "value": "#CFE1FD",
    "attributes": {
      "group": "palette",
      "category": "blue"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#CFE1FD",
      "attributes": {
        "group": "palette",
        "category": "blue"
      }
    },
    "name": "color.palette.Blue200",
    "path": [
      "color",
      "palette",
      "Blue200"
    ]
  },
  {
    "value": "#ADCBFB",
    "attributes": {
      "group": "palette",
      "category": "blue"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#ADCBFB",
      "attributes": {
        "group": "palette",
        "category": "blue"
      }
    },
    "name": "color.palette.Blue250",
    "path": [
      "color",
      "palette",
      "Blue250"
    ]
  },
  {
    "value": "#8FB8F6",
    "attributes": {
      "group": "palette",
      "category": "blue"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#8FB8F6",
      "attributes": {
        "group": "palette",
        "category": "blue"
      }
    },
    "name": "color.palette.Blue300",
    "path": [
      "color",
      "palette",
      "Blue300"
    ]
  },
  {
    "value": "#669DF1",
    "attributes": {
      "group": "palette",
      "category": "blue"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#669DF1",
      "attributes": {
        "group": "palette",
        "category": "blue"
      }
    },
    "name": "color.palette.Blue400",
    "path": [
      "color",
      "palette",
      "Blue400"
    ]
  },
  {
    "value": "#4688EC",
    "attributes": {
      "group": "palette",
      "category": "blue"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#4688EC",
      "attributes": {
        "group": "palette",
        "category": "blue"
      }
    },
    "name": "color.palette.Blue500",
    "path": [
      "color",
      "palette",
      "Blue500"
    ]
  },
  {
    "value": "#357DE8",
    "attributes": {
      "group": "palette",
      "category": "blue"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#357DE8",
      "attributes": {
        "group": "palette",
        "category": "blue"
      }
    },
    "name": "color.palette.Blue600",
    "path": [
      "color",
      "palette",
      "Blue600"
    ]
  },
  {
    "value": "#1868DB",
    "attributes": {
      "group": "palette",
      "category": "blue"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#1868DB",
      "attributes": {
        "group": "palette",
        "category": "blue"
      }
    },
    "name": "color.palette.Blue700",
    "path": [
      "color",
      "palette",
      "Blue700"
    ]
  },
  {
    "value": "#1558BC",
    "attributes": {
      "group": "palette",
      "category": "blue"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#1558BC",
      "attributes": {
        "group": "palette",
        "category": "blue"
      }
    },
    "name": "color.palette.Blue800",
    "path": [
      "color",
      "palette",
      "Blue800"
    ]
  },
  {
    "value": "#144794",
    "attributes": {
      "group": "palette",
      "category": "blue"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#144794",
      "attributes": {
        "group": "palette",
        "category": "blue"
      }
    },
    "name": "color.palette.Blue850",
    "path": [
      "color",
      "palette",
      "Blue850"
    ]
  },
  {
    "value": "#123263",
    "attributes": {
      "group": "palette",
      "category": "blue"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#123263",
      "attributes": {
        "group": "palette",
        "category": "blue"
      }
    },
    "name": "color.palette.Blue900",
    "path": [
      "color",
      "palette",
      "Blue900"
    ]
  },
  {
    "value": "#1C2B42",
    "attributes": {
      "group": "palette",
      "category": "blue"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#1C2B42",
      "attributes": {
        "group": "palette",
        "category": "blue"
      }
    },
    "name": "color.palette.Blue1000",
    "path": [
      "color",
      "palette",
      "Blue1000"
    ]
  },
  {
    "value": "#F8EEFE",
    "attributes": {
      "group": "palette",
      "category": "purple"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#F8EEFE",
      "attributes": {
        "group": "palette",
        "category": "purple"
      }
    },
    "name": "color.palette.Purple100",
    "path": [
      "color",
      "palette",
      "Purple100"
    ]
  },
  {
    "value": "#EED7FC",
    "attributes": {
      "group": "palette",
      "category": "purple"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#EED7FC",
      "attributes": {
        "group": "palette",
        "category": "purple"
      }
    },
    "name": "color.palette.Purple200",
    "path": [
      "color",
      "palette",
      "Purple200"
    ]
  },
  {
    "value": "#E3BDFA",
    "attributes": {
      "group": "palette",
      "category": "purple"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#E3BDFA",
      "attributes": {
        "group": "palette",
        "category": "purple"
      }
    },
    "name": "color.palette.Purple250",
    "path": [
      "color",
      "palette",
      "Purple250"
    ]
  },
  {
    "value": "#D8A0F7",
    "attributes": {
      "group": "palette",
      "category": "purple"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#D8A0F7",
      "attributes": {
        "group": "palette",
        "category": "purple"
      }
    },
    "name": "color.palette.Purple300",
    "path": [
      "color",
      "palette",
      "Purple300"
    ]
  },
  {
    "value": "#C97CF4",
    "attributes": {
      "group": "palette",
      "category": "purple"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#C97CF4",
      "attributes": {
        "group": "palette",
        "category": "purple"
      }
    },
    "name": "color.palette.Purple400",
    "path": [
      "color",
      "palette",
      "Purple400"
    ]
  },
  {
    "value": "#BF63F3",
    "attributes": {
      "group": "palette",
      "category": "purple"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#BF63F3",
      "attributes": {
        "group": "palette",
        "category": "purple"
      }
    },
    "name": "color.palette.Purple500",
    "path": [
      "color",
      "palette",
      "Purple500"
    ]
  },
  {
    "value": "#AF59E1",
    "attributes": {
      "group": "palette",
      "category": "purple"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#AF59E1",
      "attributes": {
        "group": "palette",
        "category": "purple"
      }
    },
    "name": "color.palette.Purple600",
    "path": [
      "color",
      "palette",
      "Purple600"
    ]
  },
  {
    "value": "#964AC0",
    "attributes": {
      "group": "palette",
      "category": "purple"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#964AC0",
      "attributes": {
        "group": "palette",
        "category": "purple"
      }
    },
    "name": "color.palette.Purple700",
    "path": [
      "color",
      "palette",
      "Purple700"
    ]
  },
  {
    "value": "#803FA5",
    "attributes": {
      "group": "palette",
      "category": "purple"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#803FA5",
      "attributes": {
        "group": "palette",
        "category": "purple"
      }
    },
    "name": "color.palette.Purple800",
    "path": [
      "color",
      "palette",
      "Purple800"
    ]
  },
  {
    "value": "#673286",
    "attributes": {
      "group": "palette",
      "category": "purple"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#673286",
      "attributes": {
        "group": "palette",
        "category": "purple"
      }
    },
    "name": "color.palette.Purple850",
    "path": [
      "color",
      "palette",
      "Purple850"
    ]
  },
  {
    "value": "#48245D",
    "attributes": {
      "group": "palette",
      "category": "purple"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#48245D",
      "attributes": {
        "group": "palette",
        "category": "purple"
      }
    },
    "name": "color.palette.Purple900",
    "path": [
      "color",
      "palette",
      "Purple900"
    ]
  },
  {
    "value": "#35243F",
    "attributes": {
      "group": "palette",
      "category": "purple"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#35243F",
      "attributes": {
        "group": "palette",
        "category": "purple"
      }
    },
    "name": "color.palette.Purple1000",
    "path": [
      "color",
      "palette",
      "Purple1000"
    ]
  },
  {
    "value": "#FFECF8",
    "attributes": {
      "group": "palette",
      "category": "magenta"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#FFECF8",
      "attributes": {
        "group": "palette",
        "category": "magenta"
      }
    },
    "name": "color.palette.Magenta100",
    "path": [
      "color",
      "palette",
      "Magenta100"
    ]
  },
  {
    "value": "#FDD0EC",
    "attributes": {
      "group": "palette",
      "category": "magenta"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#FDD0EC",
      "attributes": {
        "group": "palette",
        "category": "magenta"
      }
    },
    "name": "color.palette.Magenta200",
    "path": [
      "color",
      "palette",
      "Magenta200"
    ]
  },
  {
    "value": "#FCB6E1",
    "attributes": {
      "group": "palette",
      "category": "magenta"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#FCB6E1",
      "attributes": {
        "group": "palette",
        "category": "magenta"
      }
    },
    "name": "color.palette.Magenta250",
    "path": [
      "color",
      "palette",
      "Magenta250"
    ]
  },
  {
    "value": "#F797D2",
    "attributes": {
      "group": "palette",
      "category": "magenta"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#F797D2",
      "attributes": {
        "group": "palette",
        "category": "magenta"
      }
    },
    "name": "color.palette.Magenta300",
    "path": [
      "color",
      "palette",
      "Magenta300"
    ]
  },
  {
    "value": "#E774BB",
    "attributes": {
      "group": "palette",
      "category": "magenta"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#E774BB",
      "attributes": {
        "group": "palette",
        "category": "magenta"
      }
    },
    "name": "color.palette.Magenta400",
    "path": [
      "color",
      "palette",
      "Magenta400"
    ]
  },
  {
    "value": "#DA62AC",
    "attributes": {
      "group": "palette",
      "category": "magenta"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#DA62AC",
      "attributes": {
        "group": "palette",
        "category": "magenta"
      }
    },
    "name": "color.palette.Magenta500",
    "path": [
      "color",
      "palette",
      "Magenta500"
    ]
  },
  {
    "value": "#CD519D",
    "attributes": {
      "group": "palette",
      "category": "magenta"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#CD519D",
      "attributes": {
        "group": "palette",
        "category": "magenta"
      }
    },
    "name": "color.palette.Magenta600",
    "path": [
      "color",
      "palette",
      "Magenta600"
    ]
  },
  {
    "value": "#AE4787",
    "attributes": {
      "group": "palette",
      "category": "magenta"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#AE4787",
      "attributes": {
        "group": "palette",
        "category": "magenta"
      }
    },
    "name": "color.palette.Magenta700",
    "path": [
      "color",
      "palette",
      "Magenta700"
    ]
  },
  {
    "value": "#943D73",
    "attributes": {
      "group": "palette",
      "category": "magenta"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#943D73",
      "attributes": {
        "group": "palette",
        "category": "magenta"
      }
    },
    "name": "color.palette.Magenta800",
    "path": [
      "color",
      "palette",
      "Magenta800"
    ]
  },
  {
    "value": "#77325B",
    "attributes": {
      "group": "palette",
      "category": "magenta"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#77325B",
      "attributes": {
        "group": "palette",
        "category": "magenta"
      }
    },
    "name": "color.palette.Magenta850",
    "path": [
      "color",
      "palette",
      "Magenta850"
    ]
  },
  {
    "value": "#50253F",
    "attributes": {
      "group": "palette",
      "category": "magenta"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#50253F",
      "attributes": {
        "group": "palette",
        "category": "magenta"
      }
    },
    "name": "color.palette.Magenta900",
    "path": [
      "color",
      "palette",
      "Magenta900"
    ]
  },
  {
    "value": "#3D2232",
    "attributes": {
      "group": "palette",
      "category": "magenta"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#3D2232",
      "attributes": {
        "group": "palette",
        "category": "magenta"
      }
    },
    "name": "color.palette.Magenta1000",
    "path": [
      "color",
      "palette",
      "Magenta1000"
    ]
  },
  {
    "value": "#FFFFFF",
    "attributes": {
      "group": "palette",
      "category": "light mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#FFFFFF",
      "attributes": {
        "group": "palette",
        "category": "light mode neutral"
      }
    },
    "name": "color.palette.Neutral0",
    "path": [
      "color",
      "palette",
      "Neutral0"
    ]
  },
  {
    "value": "#F8F8F8",
    "attributes": {
      "group": "palette",
      "category": "light mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#F8F8F8",
      "attributes": {
        "group": "palette",
        "category": "light mode neutral"
      }
    },
    "name": "color.palette.Neutral100",
    "path": [
      "color",
      "palette",
      "Neutral100"
    ]
  },
  {
    "value": "#F0F1F2",
    "attributes": {
      "group": "palette",
      "category": "light mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#F0F1F2",
      "attributes": {
        "group": "palette",
        "category": "light mode neutral"
      }
    },
    "name": "color.palette.Neutral200",
    "path": [
      "color",
      "palette",
      "Neutral200"
    ]
  },
  {
    "value": "#DDDEE1",
    "attributes": {
      "group": "palette",
      "category": "light mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#DDDEE1",
      "attributes": {
        "group": "palette",
        "category": "light mode neutral"
      }
    },
    "name": "color.palette.Neutral300",
    "path": [
      "color",
      "palette",
      "Neutral300"
    ]
  },
  {
    "value": "#B7B9BE",
    "attributes": {
      "group": "palette",
      "category": "light mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#B7B9BE",
      "attributes": {
        "group": "palette",
        "category": "light mode neutral"
      }
    },
    "name": "color.palette.Neutral400",
    "path": [
      "color",
      "palette",
      "Neutral400"
    ]
  },
  {
    "value": "#8C8F97",
    "attributes": {
      "group": "palette",
      "category": "light mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#8C8F97",
      "attributes": {
        "group": "palette",
        "category": "light mode neutral"
      }
    },
    "name": "color.palette.Neutral500",
    "path": [
      "color",
      "palette",
      "Neutral500"
    ]
  },
  {
    "value": "#7D818A",
    "attributes": {
      "group": "palette",
      "category": "light mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#7D818A",
      "attributes": {
        "group": "palette",
        "category": "light mode neutral"
      }
    },
    "name": "color.palette.Neutral600",
    "path": [
      "color",
      "palette",
      "Neutral600"
    ]
  },
  {
    "value": "#6B6E76",
    "attributes": {
      "group": "palette",
      "category": "light mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#6B6E76",
      "attributes": {
        "group": "palette",
        "category": "light mode neutral"
      }
    },
    "name": "color.palette.Neutral700",
    "path": [
      "color",
      "palette",
      "Neutral700"
    ]
  },
  {
    "value": "#505258",
    "attributes": {
      "group": "palette",
      "category": "light mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#505258",
      "attributes": {
        "group": "palette",
        "category": "light mode neutral"
      }
    },
    "name": "color.palette.Neutral800",
    "path": [
      "color",
      "palette",
      "Neutral800"
    ]
  },
  {
    "value": "#3B3D42",
    "attributes": {
      "group": "palette",
      "category": "light mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#3B3D42",
      "attributes": {
        "group": "palette",
        "category": "light mode neutral"
      }
    },
    "name": "color.palette.Neutral900",
    "path": [
      "color",
      "palette",
      "Neutral900"
    ]
  },
  {
    "value": "#292A2E",
    "attributes": {
      "group": "palette",
      "category": "light mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#292A2E",
      "attributes": {
        "group": "palette",
        "category": "light mode neutral"
      }
    },
    "name": "color.palette.Neutral1000",
    "path": [
      "color",
      "palette",
      "Neutral1000"
    ]
  },
  {
    "value": "#1E1F21",
    "attributes": {
      "group": "palette",
      "category": "light mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#1E1F21",
      "attributes": {
        "group": "palette",
        "category": "light mode neutral"
      }
    },
    "name": "color.palette.Neutral1100",
    "path": [
      "color",
      "palette",
      "Neutral1100"
    ]
  },
  {
    "value": "#17171708",
    "attributes": {
      "group": "palette",
      "category": "light mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#17171708",
      "attributes": {
        "group": "palette",
        "category": "light mode neutral"
      }
    },
    "name": "color.palette.Neutral100A",
    "path": [
      "color",
      "palette",
      "Neutral100A"
    ]
  },
  {
    "value": "#0515240F",
    "attributes": {
      "group": "palette",
      "category": "light mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#0515240F",
      "attributes": {
        "group": "palette",
        "category": "light mode neutral"
      }
    },
    "name": "color.palette.Neutral200A",
    "path": [
      "color",
      "palette",
      "Neutral200A"
    ]
  },
  {
    "value": "#0B120E24",
    "attributes": {
      "group": "palette",
      "category": "light mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#0B120E24",
      "attributes": {
        "group": "palette",
        "category": "light mode neutral"
      }
    },
    "name": "color.palette.Neutral300A",
    "path": [
      "color",
      "palette",
      "Neutral300A"
    ]
  },
  {
    "value": "#080F214A",
    "attributes": {
      "group": "palette",
      "category": "light mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#080F214A",
      "attributes": {
        "group": "palette",
        "category": "light mode neutral"
      }
    },
    "name": "color.palette.Neutral400A",
    "path": [
      "color",
      "palette",
      "Neutral400A"
    ]
  },
  {
    "value": "#050C1F75",
    "attributes": {
      "group": "palette",
      "category": "light mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#050C1F75",
      "attributes": {
        "group": "palette",
        "category": "light mode neutral"
      }
    },
    "name": "color.palette.Neutral500A",
    "path": [
      "color",
      "palette",
      "Neutral500A"
    ]
  },
  {
    "value": "#111213",
    "attributes": {
      "group": "palette",
      "category": "dark mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#111213",
      "attributes": {
        "group": "palette",
        "category": "dark mode neutral"
      }
    },
    "name": "color.palette.DarkNeutral-100",
    "path": [
      "color",
      "palette",
      "DarkNeutral-100"
    ]
  },
  {
    "value": "#18191A",
    "attributes": {
      "group": "palette",
      "category": "dark mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#18191A",
      "attributes": {
        "group": "palette",
        "category": "dark mode neutral"
      }
    },
    "name": "color.palette.DarkNeutral0",
    "path": [
      "color",
      "palette",
      "DarkNeutral0"
    ]
  },
  {
    "value": "#1F1F21",
    "attributes": {
      "group": "palette",
      "category": "dark mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#1F1F21",
      "attributes": {
        "group": "palette",
        "category": "dark mode neutral"
      }
    },
    "name": "color.palette.DarkNeutral100",
    "path": [
      "color",
      "palette",
      "DarkNeutral100"
    ]
  },
  {
    "value": "#242528",
    "attributes": {
      "group": "palette",
      "category": "dark mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#242528",
      "attributes": {
        "group": "palette",
        "category": "dark mode neutral"
      }
    },
    "name": "color.palette.DarkNeutral200",
    "path": [
      "color",
      "palette",
      "DarkNeutral200"
    ]
  },
  {
    "value": "#2B2C2F",
    "attributes": {
      "group": "palette",
      "category": "dark mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#2B2C2F",
      "attributes": {
        "group": "palette",
        "category": "dark mode neutral"
      }
    },
    "name": "color.palette.DarkNeutral250",
    "path": [
      "color",
      "palette",
      "DarkNeutral250"
    ]
  },
  {
    "value": "#303134",
    "attributes": {
      "group": "palette",
      "category": "dark mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#303134",
      "attributes": {
        "group": "palette",
        "category": "dark mode neutral"
      }
    },
    "name": "color.palette.DarkNeutral300",
    "path": [
      "color",
      "palette",
      "DarkNeutral300"
    ]
  },
  {
    "value": "#3D3F43",
    "attributes": {
      "group": "palette",
      "category": "dark mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#3D3F43",
      "attributes": {
        "group": "palette",
        "category": "dark mode neutral"
      }
    },
    "name": "color.palette.DarkNeutral350",
    "path": [
      "color",
      "palette",
      "DarkNeutral350"
    ]
  },
  {
    "value": "#4B4D51",
    "attributes": {
      "group": "palette",
      "category": "dark mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#4B4D51",
      "attributes": {
        "group": "palette",
        "category": "dark mode neutral"
      }
    },
    "name": "color.palette.DarkNeutral400",
    "path": [
      "color",
      "palette",
      "DarkNeutral400"
    ]
  },
  {
    "value": "#63666B",
    "attributes": {
      "group": "palette",
      "category": "dark mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#63666B",
      "attributes": {
        "group": "palette",
        "category": "dark mode neutral"
      }
    },
    "name": "color.palette.DarkNeutral500",
    "path": [
      "color",
      "palette",
      "DarkNeutral500"
    ]
  },
  {
    "value": "#7E8188",
    "attributes": {
      "group": "palette",
      "category": "dark mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#7E8188",
      "attributes": {
        "group": "palette",
        "category": "dark mode neutral"
      }
    },
    "name": "color.palette.DarkNeutral600",
    "path": [
      "color",
      "palette",
      "DarkNeutral600"
    ]
  },
  {
    "value": "#96999E",
    "attributes": {
      "group": "palette",
      "category": "dark mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#96999E",
      "attributes": {
        "group": "palette",
        "category": "dark mode neutral"
      }
    },
    "name": "color.palette.DarkNeutral700",
    "path": [
      "color",
      "palette",
      "DarkNeutral700"
    ]
  },
  {
    "value": "#A9ABAF",
    "attributes": {
      "group": "palette",
      "category": "dark mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#A9ABAF",
      "attributes": {
        "group": "palette",
        "category": "dark mode neutral"
      }
    },
    "name": "color.palette.DarkNeutral800",
    "path": [
      "color",
      "palette",
      "DarkNeutral800"
    ]
  },
  {
    "value": "#BFC1C4",
    "attributes": {
      "group": "palette",
      "category": "dark mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#BFC1C4",
      "attributes": {
        "group": "palette",
        "category": "dark mode neutral"
      }
    },
    "name": "color.palette.DarkNeutral900",
    "path": [
      "color",
      "palette",
      "DarkNeutral900"
    ]
  },
  {
    "value": "#CECFD2",
    "attributes": {
      "group": "palette",
      "category": "dark mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#CECFD2",
      "attributes": {
        "group": "palette",
        "category": "dark mode neutral"
      }
    },
    "name": "color.palette.DarkNeutral1000",
    "path": [
      "color",
      "palette",
      "DarkNeutral1000"
    ]
  },
  {
    "value": "#E2E3E4",
    "attributes": {
      "group": "palette",
      "category": "dark mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#E2E3E4",
      "attributes": {
        "group": "palette",
        "category": "dark mode neutral"
      }
    },
    "name": "color.palette.DarkNeutral1100",
    "path": [
      "color",
      "palette",
      "DarkNeutral1100"
    ]
  },
  {
    "value": "#01040475",
    "attributes": {
      "group": "palette",
      "category": "dark mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#01040475",
      "attributes": {
        "group": "palette",
        "category": "dark mode neutral"
      }
    },
    "name": "color.palette.DarkNeutral-100A",
    "path": [
      "color",
      "palette",
      "DarkNeutral-100A"
    ]
  },
  {
    "value": "#BDBDBD0A",
    "attributes": {
      "group": "palette",
      "category": "dark mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#BDBDBD0A",
      "attributes": {
        "group": "palette",
        "category": "dark mode neutral"
      }
    },
    "name": "color.palette.DarkNeutral100A",
    "path": [
      "color",
      "palette",
      "DarkNeutral100A"
    ]
  },
  {
    "value": "#CECED912",
    "attributes": {
      "group": "palette",
      "category": "dark mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#CECED912",
      "attributes": {
        "group": "palette",
        "category": "dark mode neutral"
      }
    },
    "name": "color.palette.DarkNeutral200A",
    "path": [
      "color",
      "palette",
      "DarkNeutral200A"
    ]
  },
  {
    "value": "#D9DAE71A",
    "attributes": {
      "group": "palette",
      "category": "dark mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#D9DAE71A",
      "attributes": {
        "group": "palette",
        "category": "dark mode neutral"
      }
    },
    "name": "color.palette.DarkNeutral250A",
    "path": [
      "color",
      "palette",
      "DarkNeutral250A"
    ]
  },
  {
    "value": "#E3E4F21F",
    "attributes": {
      "group": "palette",
      "category": "dark mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#E3E4F21F",
      "attributes": {
        "group": "palette",
        "category": "dark mode neutral"
      }
    },
    "name": "color.palette.DarkNeutral300A",
    "path": [
      "color",
      "palette",
      "DarkNeutral300A"
    ]
  },
  {
    "value": "#E8EDFD2E",
    "attributes": {
      "group": "palette",
      "category": "dark mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#E8EDFD2E",
      "attributes": {
        "group": "palette",
        "category": "dark mode neutral"
      }
    },
    "name": "color.palette.DarkNeutral350A",
    "path": [
      "color",
      "palette",
      "DarkNeutral350A"
    ]
  },
  {
    "value": "#E5E9F640",
    "attributes": {
      "group": "palette",
      "category": "dark mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#E5E9F640",
      "attributes": {
        "group": "palette",
        "category": "dark mode neutral"
      }
    },
    "name": "color.palette.DarkNeutral400A",
    "path": [
      "color",
      "palette",
      "DarkNeutral400A"
    ]
  },
  {
    "value": "#E9F0FB5C",
    "attributes": {
      "group": "palette",
      "category": "dark mode neutral"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": "#E9F0FB5C",
      "attributes": {
        "group": "palette",
        "category": "dark mode neutral"
      }
    },
    "name": "color.palette.DarkNeutral500A",
    "path": [
      "color",
      "palette",
      "DarkNeutral500A"
    ]
  },
  {
    "value": 0.2,
    "attributes": {
      "group": "palette",
      "category": "opacity"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": 0.2,
      "attributes": {
        "group": "palette",
        "category": "opacity"
      }
    },
    "name": "value.opacity.Opacity20",
    "path": [
      "value",
      "opacity",
      "Opacity20"
    ]
  },
  {
    "value": 0.4,
    "attributes": {
      "group": "palette",
      "category": "opacity"
    },
    "filePath": "schema/palettes/palette.tsx",
    "isSource": true,
    "original": {
      "value": 0.4,
      "attributes": {
        "group": "palette",
        "category": "opacity"
      }
    },
    "name": "value.opacity.Opacity40",
    "path": [
      "value",
      "opacity",
      "Opacity40"
    ]
  }
];

export default tokens;
